export default function TitleBar({ title, draggable, onPointerDown, onClose, onMinimize, onToggleFullScreen }) {
  return (
    <div
      className={`h-9 bg-gradient-to-b from-[#3a3a3c] to-[#2c2c2e] flex items-center px-3 relative border-b border-black/40 select-none ${
        draggable ? "cursor-grab active:cursor-grabbing" : ""
      }`}
      onMouseDown={onPointerDown}
      onTouchStart={onPointerDown}
    >
      <div className="flex gap-2 group">
        <button
          aria-label="Close"
          onClick={onClose}
          className="w-3 h-3 rounded-full bg-[#ff5f56] border border-black/10 flex items-center justify-center text-[7px] text-black/0 group-hover:text-black/50"
        >
          ×
        </button>
        <button
          aria-label="Minimize"
          onClick={onMinimize}
          className="w-3 h-3 rounded-full bg-[#ffbd2e] border border-black/10 flex items-center justify-center text-[7px] text-black/0 group-hover:text-black/50"
        >
          −
        </button>
        <button
          aria-label="Toggle fullscreen"
          onClick={onToggleFullScreen}
          className="w-3 h-3 rounded-full bg-[#27c93f] border border-black/10 flex items-center justify-center text-[7px] text-black/0 group-hover:text-black/50"
        >
          +
        </button>
      </div>
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <span className="text-[12px] text-neutral-300/80 font-medium">{title}</span>
      </div>
    </div>
  );
}